import Vue from "vue";
import Router from "vue-router";
/**error 401 */
const Page401 = (r) =>
    require.ensure([], () => r(require("@/views/errorPage/401.vue")));
/* 从节点后台 */
const slaveLogin = (r) =>
    require.ensure([], () => r(require("@/views/slave/Login.vue")));
const slaveHome = (r) =>
    require.ensure([], () => r(require("@/views/slave/home/Home.vue")));
/**面板 */
const slaveDashboard = (r) =>
    require.ensure([], () => r(require("@/views/slave/dashboard/Dashboard.vue")));
/**流程管理 */
const flowManagement = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/flowManagement/flowManagement.vue"))
    );
/**创建流程 */
const flowAdd = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/flowManagement/flowAdd.vue"))
    );
/**编辑流程 */
const flowDetail = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/flowManagement/flowDetail.vue"))
    );
/* 授权管理 */
const authorizeManage = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/authorizeManagement/authorizeManagement.vue"))
    );
/* 授权管理（编辑） */
const authorizeEdit = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/authorizeManagement/authorizeEdit.vue"))
    );
/* 授权管理（详情） */
const authorizeDetail = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/authorizeManagement/authorizeDetail.vue"))
    );
/* 业务管理（原订单管理）*/
const orderManagement = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/orderManagement/orderManagement.vue"))
    );
/* 定位订单 */
const orderPositioning = (r) =>
    require.ensure([], () =>
        r(
            require("@/views/slave/orderManagement/orderPositioning/orderPositioning.vue")
        )
    );
/* 订单详情 */
const positioningDetail = (r) =>
    require.ensure([], () =>
        r(
            require("@/views/slave/orderManagement/positioningDetail/positioningDetail.vue")
        )
    );
/* 企业信息 */
const companyInfo = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/companyInfo/companyInfo.vue"))
    );
/**数据管理 */
const dataManagement = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/dataManagement/dataManagement.vue"))
    );
/**数据管理详情 */
const dataDetail = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/dataManagement/dataDetail.vue"))
    );
/**订阅管理 */
const subscribeManagement = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/subscribeManagement/subscribeManagement.vue"))
    );
/**生命周期管理 */
const lifeManagement = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/lifeManagement/lifeManagement.vue"))
    );
/**生命周期编辑 */
const lifeAdd = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/lifeManagement/lifeAdd.vue"))
    );

/**用户管理，*/
const slaveUserManagement = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/userManagement/userManagement.vue"))
    );
/**操作管理，*/
const operateManagement = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/operateManagement/operateManagement.vue"))
    );
const operateDetail = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/operateManagement/operateDetail.vue"))
    );
// const addUser = r => require.ensure([], () => r(require('@/views/slave/userManagement/addUser/addUser.vue')))
const userDetail = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/userManagement/userDetail/userDetail.vue"))
    );
const roleConfig = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/userManagement/roleConfig/roleConfig.vue"))
    );
/* 标识管理/标识注册 */
const slaveSignManagement = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/signManagement/signManagement.vue"))
    );
/* 标识注册 */
const slaveSignRegistration = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/signManagement/signRegistration.vue"))
    );
/* 大亚标识注册 */
const slaveDySignRegistration = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/signManagement/DySignRegistration.vue"))
    )
const slaveSignDetail = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/signManagement/signDetail.vue"))
    );
/* 快捷接入 */
const quickAccess = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/quickAccess/quickAccess.vue"))
    );
/* 快捷接入详情*/
const accessDetail = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/quickAccess/accessDetail/accessDetail.vue"))
    );
/* 接入历史 */
const accessHistory = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/quickAccess/accessHistory/accessHistory.vue"))
    );

/**二维码-扫码记录 */
const scanRecord = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/qrCodeManagement/scanRecord.vue"))
    );

/**二维码-看板 */
const codeDashboard = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/qrCodeManagement/codeDashboard.vue"))
    );
/**个性化样式 */
const styleManagement = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/qrCodeManagement/styleManagement.vue"))
    );
/**接口说明 */
const interfaceInfo = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/interfaceInfo/interfaceInfo.vue"))
    );

/* 应用管理 */
const applicationManage = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/applicationManagement/applicationManagement.vue"))
    );
/* 应用管理(详情) */
const applicationDetail = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/applicationManagement/applicationDetail.vue"))
    );
/** 标识关联  关联管理*/
const identityMap = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/identityMap/identityMap.vue"))
    );
/**关联类型  */
const identityMapType = (r) => require.ensure([], () => r(require("@/views/slave/identityMap/identityMapType.vue")));

/** 快速了解 */
const quickStart = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/quickStart/quickStart.vue"))
    );
/**操作日志 */
const operation = (r) =>
    require.ensure([], () =>
        r(require("@/views/slave/operation/operation.vue"))
    );
/**当前模板 */
const TemplatePanel = (r) => require.ensure([], () => r(require("@/views/slave/templateManagement/TemplatePanel.vue")))
/**模板维护 */
const TemplateMaintenance = (r) => require.ensure([], () => r(require("@/views/slave/templateManagement/TemplateMaintenance.vue")))
const TemplateMaintenanceNew = (r) => require.ensure([], () => r(require("@/views/slave/templateManagement/TemplateMaintenanceNew.vue")))
/**成品管理 */
const finishedProductManage = (r) => require.ensure([], () => r(require("@/views/slave/finishedProductmanage/finishedProductmanage.vue")))
const finishedProductDetail = (r) => require.ensure([], () => r(require("@/views/slave/finishedProductmanage/finishedProductdetail.vue")))
/**板材追溯码 */
const plateTraceability = (r) => require.ensure([], () => r(require("@/views/slave/plateTraceabilityManagement/plateTraceability/plateTraceability.vue")))
const searchRecord = (r) => require.ensure([], () => r(require("@/views/slave/plateTraceabilityManagement/searchRecord/searchRecord.vue")))
const securityLabel = (r) => require.ensure([], () => r(require("@/views/slave/plateTraceabilityManagement/securityLabel/securityLabel.vue")))
const zxxbSecurityLabe = (r) => require.ensure([], () => r(require("@/views/slave/plateTraceabilityManagement/zxxbSecurityLabe/securityLabel.vue")))

/**精版横版追溯码 */
const refinedsecurityLabel = (r) => require.ensure([], () => r(require("@/views/slave/refinedsecurityLabel/securityLabel/securityLabel.vue")))
/**精版竖版追溯码 */
const portraitSecurityLabel = (r) => require.ensure([], () => r(require("@/views/slave/portraitSecurityLabel/securityLabel/securityLabel.vue")))
/**竹香板追溯码 */
const zxbSecurityLabe = (r) => require.ensure([], () => r(require("@/views/slave/zxbSecurityLabe/securityLabel/securityLabel.vue")))
/**大亚生态板 */
const dySecurityLabe = (r) => require.ensure([], () => r(require("@/views/slave/dySecurityLabe/securityLabel.vue")))
// 大亚海芯板
const dyHxSecurityLabel = (r) => require.ensure([], () => r(require("@/views/slave/dyHxSecurityLabel/securityLabel.vue")))
/**大亚锦绣板 */
const dyJxSecurityLabe = (r) => require.ensure([], () => r(require("@/views/slave/dyJxSecurityLabel/securityLabel.vue")))
/**南宁防伪小标签 */
const dyNnSecurityLabe = (r) => require.ensure([], () => r(require("@/views/slave/dyNnSecurityLabel/securityLabel.vue")))
/**大亚圣象饰面板 */
const dySmSecurityLabe = (r) => require.ensure([], () => r(require("@/views/slave/dySmSecurityLabel/securityLabel.vue")))

/**h5 */
const securityCheck = (r) => require.ensure([], () => r(require("@/views/slave/h5/securityCheck.vue")))
const scanCode = (r) => require.ensure([], () => r(require("@/views/slave/h5/scanCode.vue")))
const newScanCode = (r) => require.ensure([], () => r(require("@/views/slave/h5/newScanCode.vue")))
const identification = (r) => require.ensure([], () => r(require("@/views/slave/h5/identification.vue")))
const labelIdentification = (r) => require.ensure([], () => r(require("@/views/slave/h5/labelIdentification.vue")))
const empower = (r) => require.ensure([], () => r(require("@/views/slave/h5/empower.vue")))
const empowerSearch = (r) => require.ensure([], () => r(require("@/views/slave/h5/empowerSearch.vue")))
const empowerOpacitySearch = (r) => require.ensure([], () => r(require("@/views/slave/h5/empowerOpacitySearch.vue")))
const empowerImg = (r) => require.ensure([], () => r(require("@/views/slave/h5/empowerImg.vue")))



/**经销商管理 */
const dealerManagement = (r) => require.ensure([], () => r(require("@/views/slave/dealerManagement/dealerManagement.vue")))
const empowerCustomerManagement = (r) => require.ensure([], () => r(require("@/views/slave/empowerCustomerManagement/empowerCustomerManagement.vue")))
import NProgress from "nprogress";

Vue.use(Router);
let constRouters = [
    {
        path: "/",
        hidden: true,
        redirect: {
            name: "slaveLogin",
        },
    },
    {
        path: "/login",
        name: "slaveLogin",
        component: slaveLogin,
        hidden: true,
        meta: {
            title: "从节点登录",
            requireAuth: false,
        },
    },
    {
        path: "/slave",
        component: slaveHome,
        leaf: true, //只有一个节点
        hidden: true,
        icon: "iconyingyongfuzhi6",
        meta: {
            title: "企业信息",
        },
        children: [
            {
                path: "/slave/companyInfo",
                name: "companyInfo",
                component: companyInfo,
                meta: {
                    title: "编辑企业信息",
                },
            },
            /**当前模板 */
            {
                path: "/slave/template",
                name: "当前模板",
                component: TemplatePanel,
                meta: {
                    title: "当前模板",
                }
            },
            /**模板维护 */
            {
                path: "/slave/templateMaintenance",
                name: "模板维护",
                component: TemplateMaintenanceNew,
                meta: {
                    title: "模板维护"
                }
            }
        ],
    },
    {
        path: "/slave",
        component: slaveHome,
        leaf: true, //只有一个节点
        hidden: true,
        icon: "quickStart",
        meta: {
            title: "快速了解",
        },
        children: [
            {
                path: "/slave/quickStart",
                name: "快速了解",
                component: quickStart,
                meta: {
                    title: "标识中枢塔使用流程",
                },
            },
        ],
    },
    {
        path: "/slave",
        component: slaveHome,
        leaf: true, //只有一个节点
        hidden: true,
        icon: "quickStart",
        meta: {
            title: "错误页面",
        },
        children: [
            {
                path: "/slave/401",
                component: Page401,
                name: "401",
                meta: {
                    title: "无权限",
                },
            },
        ],
    },
    {
        path: "/401",
        component: Page401,
        name: "401",
        hidden: true,
        meta: {
            title: "无权限",
            requireAuth: false,
        },
    },
    {
        path: "/scanCode",
        component: scanCode,
        name: "防伪查询",
        hidden: true,
        meta: {
            title: "防伪查询",
            requireAuth: false,
        },
    },
    {
        path: "/newScanCode",
        component: newScanCode,
        name: "防伪查询",
        hidden: true,
        meta: {
            title: "防伪查询",
            requireAuth: false,
        },
    },
    {
        path: "/securityCheck",
        component: securityCheck,
        name: "防伪查询",
        hidden: true,
        meta: {
            title: "防伪查询",
            requireAuth: false,
        },
    },
    {
        path: "/identification",
        component: identification,
        name: "防伪查询",
        hidden: true,
        meta: {
            title: "防伪查询",
            requireAuth: false,
        },
    },
    {
        path: "/labelIdentification",
        component: labelIdentification,
        name: "防伪查询",
        hidden: true,
        meta: {
            title: "防伪查询",
            requireAuth: false,
        },
    },
    {
        path: "/empower",
        component: empower,
        name: "授权客户",
        hidden: true,
        meta: {
            title: "授权客户",
            requireAuth: false,
        },
    },
    {
        path: "/empowerSearch",
        component: empowerSearch,
        name: "授权客户",
        hidden: true,
        meta: {
            title: "授权客户",
            requireAuth: false,
        },
    },
    {
        path: "/empowerOpacitySearch",
        component: empowerOpacitySearch,
        name: "授权客户",
        hidden: true,
        meta: {
            title: "授权客户",
            requireAuth: false,
        },
    },
    {
        path: "/empowerImg",
        component: empowerImg,
        name: "授权客户",
        hidden: true,
        meta: {
            title: "授权客户",
            requireAuth: false,
        },
    },
];

/**大亚路由 */
let dareSlaveRoutes = [
    /* 从节点 */
    {
        path: "slave",
        component: slaveHome,
        leaf: false,//只有一个节点
        icon: "icon-jingxiaoshangguanli",
        name: "客户管理",
        meta: {
            auth: ["15", "19"],
            title: "客户管理",
        },
        children: [
            {
                path: "/slave/dealerManagement",
                name: "经销商管理",
                component: dealerManagement,
                meta: {
                    title: "经销商管理",
                    auth: ["15"],
                }
            },
            {
                path: "/slave/empowerCustomerManagement",
                name: "授权客户",
                component: empowerCustomerManagement,
                meta: {
                    title: "授权客户",
                    auth: ["19"],
                }
            },
        ]
    },
    {
        path: "/slave",
        component: slaveHome,
        leaf: false, //只有一个节点
        icon: "icon-bancaizhuisuma",
        name: "板材追溯码",
        meta: {
            auth: ["13", "14", "18"],
            title: "板材追溯码",
        },
        children: [
            {
                path: "/slave/plateTraceabilityManagement/plateTraceability",
                name: "板材追溯码",
                component: plateTraceability,
                meta: {
                    title: "板材追溯码",
                    auth: ["13"],
                    // bread: false
                },
            },
            {
                path: "/slave/plateTraceabilityManagement/searchRecord",
                name: "追溯码查询记录",
                component: searchRecord,
                meta: {
                    title: "追溯码查询记录",
                    auth: ["14"],
                    // bread: false
                },
            },
            {
                path: "/slave/plateTraceabilityManagement/securityLabel",
                name: "防伪小标签",
                component: securityLabel,
                meta: {
                    title: "防伪小标签",
                    auth: ["18"],
                    // bread: false
                },
            },
            {
                path: "/slave/plateTraceabilityManagement/zxxbSecurityLabe",
                name: "竹香板小标签",
                component: zxxbSecurityLabe,
                meta: {
                    title: "竹香板小标签",
                    auth: ["18"],
                    // bread: false
                },
            },
        ],
    },
    {
        path: "/slave",
        component: slaveHome,
        leaf: false, //只有一个节点
        icon: "icon-bancaizhuisuma",
        name: "红芯FOSB精板",
        meta: {
            auth: ["20"],
            title: "红芯FOSB精板",
        },
        children: [
            {
                path: "/slave/plateTraceabilityManagement/refinedsecurityLabel",
                name: "板材防伪标签",
                component: refinedsecurityLabel,
                meta: {
                    title: "板材防伪标签",
                    auth: ["20"],
                    // bread: false
                },
            },
        ],
    },
    {
        path: "/slave",
        component: slaveHome,
        leaf: false, //只有一个节点
        icon: "icon-bancaizhuisuma",
        name: "红芯ENF精板",
        meta: {
            auth: ["21"],
            title: "红芯ENF精板",
        },
        children: [
            {
                path: "/slave/plateTraceabilityManagement/portraitSecurityLabel",
                name: "板材防伪标签",
                component: portraitSecurityLabel,
                meta: {
                    title: "板材防伪标签",
                    auth: ["21"],
                    // bread: false
                },
            },
        ],
    },
    {
        path: "/slave",
        component: slaveHome,
        leaf: false, //只有一个节点
        icon: "icon-bancaizhuisuma",
        name: "大亚竹香板",
        meta: {
            auth: ["22"],
            title: "大亚竹香板",
        },
        children: [
            {
                path: "/slave/plateTraceabilityManagement/zxbSecurityLabe",
                name: "板材防伪标签",
                component: zxbSecurityLabe,
                meta: {
                    title: "板材防伪标签",
                    auth: ["22"],
                    // bread: false
                },
            },
        ],
    },
    {
        path: "/slave",
        component: slaveHome,
        leaf: false, //只有一个节点
        icon: "icon-bancaizhuisuma",
        name: "大亚生态板",
        meta: {
            auth: ["23"],
            title: "大亚生态板",
        },
        children: [
            {
                path: "/slave/dayaSecurityLabe",
                name: "板材防伪标签",
                component: dySecurityLabe,
                meta: {
                    title: "板材防伪标签",
                    auth: ["23"],
                    // bread: false
                },
            },
        ],
    },
    {
        path: "/slave",
        component: slaveHome,
        leaf: false, //只有一个节点
        icon: "icon-bancaizhuisuma",
        name: "大亚海芯板",
        meta: {
            auth: ["24"],
            title: "大亚海芯板",
        },
        children: [
            {
                path: "/slave/dyHxSecurityLabel",
                name: "板材防伪标签",
                component: dyHxSecurityLabel,
                meta: {
                    title: "板材防伪标签",
                    auth: ["24"],
                    // bread: false
                },
            },
        ],
    },
    {
        path: "/slave",
        component: slaveHome,
        leaf: false, //只有一个节点
        icon: "icon-bancaizhuisuma",
        name: "大亚锦绣系列标签",
        meta: {
            auth: ["25"],
            title: "大亚锦绣系列标签",
        },
        children: [
            {
                path: "/slave/dyJxSecurityLabe",
                name: "板材防伪标签",
                component: dyJxSecurityLabe,
                meta: {
                    title: "板材防伪标签",
                    auth: ["25"],
                    // bread: false
                },
            },
        ],
    },
    {
        path: "/slave",
        component: slaveHome,
        leaf: false, //只有一个节点
        icon: "icon-bancaizhuisuma",
        name: "南宁防伪小标签",
        meta: {
            auth: ["26"],
            title: "南宁防伪小标签",
        },
        children: [
            {
                path: "/slave/dyNnSecurityLabe",
                name: "板材防伪标签",
                component: dyNnSecurityLabe,
                meta: {
                    title: "板材防伪标签",
                    auth: ["26"],
                    // bread: false
                },
            },
        ],
    },
    {
        path: "/slave",
        component: slaveHome,
        leaf: false, //只有一个节点
        icon: "icon-bancaizhuisuma",
        name: "大亚圣象饰面板",
        meta: {
            auth: ["27"],
            title: "大亚圣象饰面板",
        },
        children: [
            {
                path: "/slave/dySmSecurityLabe",
                name: "板材防伪标签",
                component: dySmSecurityLabe,
                meta: {
                    title: "板材防伪标签",
                    auth: ["27"],
                    // bread: false
                },
            },
        ],
    },
    {
        path: "/slave",
        component: slaveHome,
        leaf: true, //只有一个节点
        name: "扫码记录",
        icon: "icon-saomajilu",
        meta: {
            auth: ["3"],
        },
        children: [
            // {
            //   path: "/slave/codeDashboard",
            //   name: "二维码",
            //   component: codeDashboard,
            //   meta: {
            //     title: "看板",
            //     auth:["2"],
            //     bread: false
            //   }
            // },
            {
                path: "/slave/scanRecord",
                name: "扫码记录",
                component: scanRecord,
                meta: {
                    title: "扫码记录",
                    auth: ["3"],
                }
            },
            // {
            //   path: "/slave/styleManagement",
            //   name: "二维码",
            //   component: styleManagement,
            //   meta: {
            //     title: "个性化样式",
            //     auth:["4"],
            //   }
            // },
        ]
    },
    {
        path: "/slave",
        component: slaveHome,
        leaf: true, //只有一个节点
        icon: "icon-biaoshiguanli",
        hidden: false,
        name: "标识管理",
        meta: {
            auth: ["5"],
        },
        children: [
            {
                path: "/slave/signManagement",
                name: "标识管理",
                component: slaveSignManagement,
                meta: {
                    title: "标识管理",
                    auth: ["5"],
                },
            },
            {
                path: "/slave/signDetail",
                name: "标识管理",
                component: slaveSignDetail,
                meta: {
                    title: "标识详情",
                    auth: ["5"],
                    activeMenu: "/slave/signManagement",
                },
            },
            {
                path: "/slave/signRegistration",
                name: "标识注册",
                component: slaveSignRegistration,
                meta: {
                    title: "标识注册",
                    auth: ["5"],
                    activeMenu: "/slave/signRegistration",
                },
            },
            {
                path: "/slave/dysignRegistration",
                name: "标识注册",
                component: slaveDySignRegistration,
                meta: {
                    title: "标识注册",
                    auth: ["5"],
                    activeMenu: "/slave/dysignRegistration",
                },
            },



        ],
    },
    {
        path: "slave",
        component: slaveHome,
        leaf: true,//只有一个节点
        icon: "icon-chengpinguanli",
        name: "成品管理",
        meta: {
            auth: ["11"],
        },
        children: [
            {
                path: "/slave/finishedProductManage",
                name: "成品管理",
                component: finishedProductManage,
                meta: {
                    title: "成品管理",
                    auth: ["11"],
                }
            },
            {
                path: "/slave/finishedProductDetail",
                name: "成品详情",
                component: finishedProductDetail,
                meta: {
                    title: "成品详情",
                    auth: ["11"],
                    activeMenu: "/slave/finishedProductManage"
                }
            }
        ]
    },
    {
        path: "/slave",
        component: slaveHome,
        leaf: true, //只有一个节点
        icon: "icon-caozuoguanli",
        name: "操作管理",
        meta: {
            auth: ["12"],
        },
        children: [
            {
                path: "/slave/operateManagement",
                name: "操作管理",
                component: operateManagement,
                meta: {
                    title: "操作管理",
                    auth: ["12"],
                    // bread: false
                },
            },
            {
                path: "/slave/operateDetail",
                name: "操作详情",
                component: operateDetail,
                meta: {
                    title: "操作详情",
                    auth: ["12"],
                },
            },

        ],
    },
    {
        path: "/slave",
        component: slaveHome,
        leaf: true, //只有一个节点
        icon: "icon-zhanghuguanli",
        name: "账户管理",
        meta: {
            auth: ["16"],
        },
        children: [
            {
                path: "/slave/userManagement",
                name: "账户管理",
                component: slaveUserManagement,
                meta: {
                    title: "账户管理",
                    auth: ["16"],
                    // bread: false
                },
            },
            {
                path: "/slave/userDetail",
                component: userDetail,
                name: "账户管理",
                hidden: true,
                meta: {
                    title: "查看员工信息",
                    auth: ["16"],
                    activeMenu: "/slave/userManagement",
                },
            },
            {
                path: "/slave/roleConfig",
                component: roleConfig,
                name: "账户管理",
                hidden: true,
                meta: {
                    title: "角色配置",
                    auth: ["16"],
                },
            },
        ],
    },
    {
        path: "/slave",
        component: slaveHome,
        leaf: true, //只有一个节点
        name: "操作日志",
        icon: "icon-caozuorizhi",
        meta: {
            auth: ["17"],
        },
        children: [
            {
                path: "/slave/operation",
                name: "操作日志",
                component: operation,
                meta: {
                    title: "操作日志",
                    auth: ["17"],
                }
            },
        ]
    },
    // { path: '*', redirect: '/401', hidden: true }
];

//合并两个路由
// let routes = new Set([...masterRoutes, ...slaveRoutes]) as any;

const router = new Router({
    routes: constRouters,
    mode: "hash",
});

/**
 * 递归查询
 */
function filterAsyncRoutes(routes, roles) {
    const res = [];
    routes.forEach((route) => {
        const tmp = { ...route };
        if (hasPermission(roles, tmp)) {
            if (tmp.children) {
                tmp.children = filterAsyncRoutes(tmp.children, roles);
            }
            res.push(tmp);
        }
    });
    return res;
}
/**
 * 过滤路由
 */
function hasPermission(roles, route) {
    if (route.meta && route.meta.auth) {
        return roles.some((role) => route.meta.auth.includes(role));
    } else {
        return true;
    }
}
/**
 * 判断路由权限
 */
// let res = false;
// function hasRole(routes, path) {
//     for (let i of routes) {
//         if (i.path == path) {
//             res = true
//         }
//         else{
//             if(i.children&&i.children.length>0){
//                 res = hasRole(i.children, path)
//             }
//         }
//     }
//     return res
// }
function hasRole(filterRoutes, path) {
    let routes = new Set([...constRouters, ...filterRoutes]) as any;
    if (JSON.stringify(routes).includes(path)) {
        return true
    } else {
        return false
    }
}
// 免登陆路径
const WHITELIST = ["/login", '/scanCode', '/newScanCode', '/securityCheck', '/identification', '/labelIdentification', '/empower', '/empowerSearch', '/empowerOpacitySearch', '/empowerImg'];
var authlist = [];
let firstTime = true;
router.beforeEach((to, from, next) => {
    //路由钩子改标题
    // if (to.meta.title) {
    //   document.title = to.meta.title;
    // }
    let cdsjwtToken = localStorage.getItem("cdsjwtToken");
    NProgress.start();
    if (cdsjwtToken) {
        if (to.path === "/login") {
            next();
            NProgress.done();
        } else {
            if (authlist.length == 0) {
                /**平台用户 */
                if (Number(localStorage.getItem("accountType")) == 0) {
                    if (localStorage.getItem("type") == "0") {
                        //普通用户
                        authlist = localStorage.getItem("pageAuth").split(",");
                        if (!localStorage.getItem("pageAuth")) {
                            //普通用户没有配置权限
                            next({
                                path: "/slave/401",
                                replace: true,
                            });
                        }
                    } else {
                        //管理员账户
                        authlist = [
                            "0",
                            "1",
                            "2",
                            "3",
                            "5",
                            "6",
                            "7",
                            "8",
                            "9",
                            "10",
                            "11",
                            "12",
                            "13",
                            "14",
                            "15",
                            "16",
                            "17",
                            "18",
                            "19",
                            "20",
                            "21",
                            "22",
                            "23",
                            "24",
                            "25",
                            "26",
                            "27",
                        ];
                    }
                } else {
                    /**经销商 */
                    //管理员账户
                    authlist = [
                        "13",
                        "14",
                    ];
                }
                if (authlist.length > 0 && authlist[0]) {
                    /**判断是否是大亚 */
                    var filterRoutes = filterAsyncRoutes(dareSlaveRoutes, authlist);
                    router["options"].routes = [...filterRoutes];
                    router.addRoutes(filterRoutes);
                    let auth = hasRole(filterRoutes, to.path);
                    if (auth) {
                        // if (to.meta.auth) {
                        //有权限正常访问
                        next({
                            name: to.name,
                            path: to.path,
                            hash: to.hash,
                            query: to.query,
                            params: to.params,
                            append: false,
                            replace: true,
                        });
                    } else {
                        if (filterRoutes[0].children[0].path) {
                            //有其他路由权限，但无访问路由权限，跳转第一个有权限的路由
                            next({
                                path: filterRoutes[0].children[0].path,
                                replace: true,
                            });
                        } else {
                            //无访问路由权限
                            next({
                                path: "/slave/401",
                                replace: true,
                            });
                        }
                    }
                }
            } else {
                next();
            }
        }
    } else {
        if (WHITELIST.indexOf(to.path) !== -1) {
            next();
        } else {
            next({
                path: "/login",
                replace: true,
            });
        }
        NProgress.done();
    }
});

router.afterEach((to, from) => {
    NProgress.done();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.ts